import { adoptPage, readPage } from "./pageHistory";

// Shows a saved page: its id, or "last" for the most recently saved one. Resolves to the
// id shown (null if there wasn't one), so navigation never gets stuck.
const loadPreviousPage = async (store, pageId = "last") => {
  if (store === undefined) {
    return null;
  }
  try {
    const saved = await readPage(pageId);
    if (!saved) return null;
    store.commit("UPDATE_ENTIRE_STATE", {
      payload: saved.state,
      dataToKeep: ["personalInfo", "auth", "tours", "wishes", "makes"],
    });
    // A page saved while the sign-in window was open shouldn't open it again for
    // someone who is now signed in
    if (store.state.auth.loggedIn) store.commit("modals/SET_AUTH_OPEN", false);
    store.dispatch("resetLoading");
    return saved.id;
  } catch (error) {
    console.error("Could not load the previous page", error);
    return null;
  }
};

// Loads the most recent page into the current history entry, so it carries on from there
const resumeLastPage = async (store) => {
  const id = await loadPreviousPage(store, "last");
  if (id !== null) adoptPage(id);
  return id;
};

const timeOfLastPage = async () => {
  try {
    const saved = await readPage("last");
    return saved ? saved.time : null;
  } catch {
    return null;
  }
};

export { loadPreviousPage, resumeLastPage, timeOfLastPage };
